import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import '../styles/top-banner-stocks.css'

document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.slider-block .swiper', {
        loop: true,
        autoplay: { delay: 5000 },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    });
});